<div class="grid col-12 p-0" *ngIf="selectedClass && !disable">
  <!-- Кнопка Добавить участника -->
  <button
    class="col-fixed"
    style="width: 200px"
    pButton
    type="button"
    [disabled]="disable || !competitorPhone"
    [label]="settingsService.translate[settingsService.selectedLang]['add_reg']"
    (click)="searchCompetitor()"
  ></button>
  <!-- Ввод телефона для добавления -->
  <span class="p-float-label">
    <app-intl-phone-input
      [cssClass]="'full-width'"
      [selectedCountryISO]="countryCode"
      [maxLength]="'20'"
      [placeholder]="'Введите номер телефона'"
      [enableAutoPlaceholder]="true"
      [value]="phoneNumber"
      [disabled]="disable"
      (valueChange)="onPhoneNumberChange($event)"
      (countryChange)="onCountryChange($event)"
      (intlTelInputObject)="telInputObject($event)"
    ></app-intl-phone-input>
    <label for="inputtext">Телефон</label>
  </span>
</div>

<!-- Диалог создания нового участника - члена экипажа -->
<p-dialog
  [header]="
    settingsService.translate[settingsService.selectedLang][
      'new_competitor_dialog_title'
    ]
  "
  *ngIf="dialogNewCompetitor"
  [(visible)]="dialogNewCompetitor"
  [responsive]="true"
  [minY]="70"
  [modal]="true"
  [maximizable]="true"
  [baseZIndex]="10000"
  [style]="{'max-width': '600px'}"
>
  <race-profile
    *ngIf="newCompetitor"
    [user]="newCompetitor"
    [lang]="settingsService.selectedLang"
    [editMode]="true"
    (userChange)="onUserSaved($event)"
  ></race-profile>
</p-dialog>

<!-- Диалог добавления участника оргом -->
<div *ngIf="displayRegForm">
  <div *ngIf="selectedClass && selectedUser">
    <race-form
      [raceClasses]="raceClasses"
      [user]="selectedUser"
      [selectedClass]="selectedClass"
      [classUser]="selectedRegistration"
      [race]="race"
      mode="add_registration_by_org"
      [currentRaceClass]="currentRaceClass"
      (closeDialog)="closeRegistrationDataDialog($event)"
    ></race-form>
  </div>
</div>